<template>
  <!-- eh-ds: stylebook primitives (brand-ds.scss). Photo background stays layout. -->
  <div class="content eh-ds auth-bg">
    <div class="auth-wrapper">
      <div class="auth-card">
        <form class="auth-form" id="loginform" @submit.prevent="validateSMSCode">
          <div v-if="formErrorsIsTrue" class="auth-alert auth-alert--error">
            <p class="auth-alert__title">Please enter the 6-digit code</p>
            <ul class="auth-alert__list">
              <li
                v-for="(error, index) in returnmessageAr"
                :key="'returnMsgs' + index"
              >
                {{ error }}
              </li>
            </ul>
          </div>

          <!-- Step 1: choose SMS or email, then send the code -->
          <div v-if="showSMSSection" class="auth-section">
            <h2 class="auth-title">Verify your identity</h2>
            <p class="auth-text">
              Choose where we should send a one-time password using the contact
              information we have on file.
            </p>

            <!-- Channel picker: both contacts are always offered when loaded -->
            <div v-if="contactsLoaded" class="channel-options">
              <label class="channel-option" :class="{ active: selectedChannel === 'sms' }">
                <input
                  type="radio"
                  name="mfaChannel"
                  value="sms"
                  v-model="selectedChannel"
                />
                <span class="channel-option__body">
                  <span class="channel-option__label">Text message</span>
                  <span class="channel-option__value">{{ maskednumber }}</span>
                </span>
              </label>
              <label class="channel-option" :class="{ active: selectedChannel === 'email' }">
                <input
                  type="radio"
                  name="mfaChannel"
                  value="email"
                  v-model="selectedChannel"
                />
                <span class="channel-option__body">
                  <span class="channel-option__label">Email</span>
                  <span class="channel-option__value">{{ maskedemail }}</span>
                </span>
              </label>
            </div>
            <p v-else class="auth-text auth-text--muted">Loading contact info...</p>

            <p v-if="twilSMSError" class="auth-error">
              Not a valid number. Please use a valid number or update your profile
              information.
            </p>
            <button
              v-if="contactsLoaded"
              type="button"
              id="smsSubmit"
              class="auth-btn auth-btn--primary"
              @click="SendSMSCode()"
            >
              Send Authorization Code
            </button>
          </div>

          <!-- Step 2: enter code; resend can switch channel via radios below -->
          <div v-if="showSMSCodeSection" class="auth-section">
            <h2 class="auth-title">Enter verification code</h2>
            <!-- Replacement for success alert -->
            <div class="auth-alert auth-alert--success">
              Code sent successfully to {{ lastSentDestinationLabel }}.
            </div>
            <p class="auth-text">
              Enter the 6-digit code sent to
              <strong>{{ lastSentDestinationLabel }}</strong>.
            </p>
            <div class="codebox">
              <input
                ref="verificationCodeInput"
                type="text"
                inputmode="numeric"
                pattern="[0-9]*"
                autocomplete="one-time-code"
                maxlength="6"
                v-model="verificationCode"
                @input="onCodeInput"
                class="code-input"
                id="verificationCode"
                aria-label="6-digit verification code"
                placeholder="000000"
              />
            </div>

            <!-- Allow switching SMS/email on resend without going back to step 1 -->
            <div class="channel-options channel-options--compact">
              <p class="channel-options__hint">Resend via:</p>
              <label class="channel-option" :class="{ active: selectedChannel === 'sms' }">
                <input
                  type="radio"
                  name="mfaChannelResend"
                  value="sms"
                  v-model="selectedChannel"
                />
                <span class="channel-option__body">
                  <span class="channel-option__label">Text</span>
                  <span class="channel-option__value">{{ maskednumber }}</span>
                </span>
              </label>
              <label class="channel-option" :class="{ active: selectedChannel === 'email' }">
                <input
                  type="radio"
                  name="mfaChannelResend"
                  value="email"
                  v-model="selectedChannel"
                />
                <span class="channel-option__body">
                  <span class="channel-option__label">Email</span>
                  <span class="channel-option__value">{{ maskedemail }}</span>
                </span>
              </label>
            </div>

            <div class="auth-actions">
              <button
                type="submit"
                id="smsSubmitCode"
                class="auth-btn auth-btn--primary"
                :disabled="codeState === 'locked'"
              >
                Verify Code
              </button>
              <button
                type="button"
                id="resendverCode"
                class="auth-btn auth-btn--secondary"
                @click="ResendSendSMSCode()"
              >
                Resend Code
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import router from "@/router/index";
import { CURR_API } from "@/constants/apis";
import $ from "jquery";
import axios from "axios";
import store from "@/store/index";
import { loginCodeRefusalState, refusalMessage } from "@/api/refusals";
import { syncPrivilegesAfterSessionChange } from "@/utils/privilegesSessionSync";

export default {
  name: "six-codePage",
  components: {},

  data() {
    return {
      isvalid: [],
      hasErrors: [],
      // Masked by the server; the unmasked values never reach this page.
      maskednumber: "",
      hasPhone: false,
      // Email contact for MFA channel picker (from GetAccountSMSPHone)
      maskedemail: "",
      hasEmail: false,
      selectedChannel: "sms", // User's chosen delivery: "sms" | "email"
      lastSentChannel: "sms", // Channel used for the most recent successful send (for UI copy)
      contactsLoaded: false, // True once phone and/or email have been fetched
      isTestMode: true,
      returnmessageAr: [], //Array with Form Error Message
      formErrorsIsTrue: false, //Boolean that determins if form Errors should show
      smsUsername: "", //SMS Username
      smsPhone: "", //SMS PHone number,
      showSMSSection: true, //Boolean that determins the SMS Form State |Display or Toggle,
      showSMSCodeSection: false, //Determins if the SMS Validation section is visible
      twilSMSError: false, //Twilio Error if a non valid phone number is used
      verificationCode: "", // Full 6-digit SMS code
      didResendCode: false, //boolean action alert
      // 'idle' | 'expired' | 'locked'. A lock survives a resend: keyon counts
      // wrong attempts across re-issued codes, so only an expired code is
      // cleared by sending a new one.
      codeState: "idle",
    };
  },

  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
      isLoggedIn: "isLoggedIn",
    }),
    // Masked phone or email shown in "sent to …" / resend banner.
    lastSentDestinationLabel() {
      return this.lastSentChannel === "email" ? this.maskedemail : this.maskednumber;
    },
  },
  async mounted() {
    this.maskedNumber();
    this.checkMode();
     this.hideTopNavigation();
     // const store = useAuthStore();
    
  },
  methods: {
    focusVerificationCode() {
      this.$nextTick(() => {
        this.$refs.verificationCodeInput?.focus();
      });
    },
    checkMode() {
      if (this.isTestMode == false) {
       // alert("sholdn't be here");
        router.push({ name: "WelcomeNavigation" });
      }
    },
    onCodeInput(event) {
      const digits = String(event?.target?.value || "").replace(/\D/g, "").slice(0, 6);
      this.verificationCode = digits;
      if (event?.target) event.target.value = digits;
    },
    hideTopNavigation() {
      $("#navigation-bar").css("display", "none");
    },
    // Masking moved to the server (ProcessData::MaskPhoneForDisplay and
    // MaskEmailForDisplay): masking in the browser required sending the
    // browser the thing being masked.
    // Backend now returns "Code Sent"; still accept legacy "SMS Code Sent".
    isCodeSentResponse(message) {
      return message === "Code Sent" || message === "SMS Code Sent";
    },
    // Load phone + email for the channel picker (API still named GetAccountSMSPHone).
    async maskedNumber() {
      let content = {
        Sms: {
          API_Meth: "GetAccountSMSPHone",
          accountnumber: this.allData.patient.externId2,
          subaccountnumber: this.allData.patient.externId,
        },
      };

      try {
        const res = await axios.post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        });

        if (res.data.message === "Have Phone Number") {
          // The server masks now and sends only the masked form. It used to
          // send the real telephone number and e-mail address to this
          // unauthenticated page so that the browser could hide them, which
          // made the endpoint a way to read anybody's contact details from
          // their account number. Which channels exist comes back as booleans.
          this.maskednumber = res.data.phoneMasked ? String(res.data.phoneMasked) : "";
          this.maskedemail = res.data.emailMasked ? String(res.data.emailMasked) : "";
          this.hasPhone = !!res.data.hasPhone;
          this.hasEmail = !!res.data.hasEmail;
          this.contactsLoaded = this.hasPhone || this.hasEmail;
          // Default to email only when there is no phone on file.
          if (!this.hasPhone && this.hasEmail) {
            this.selectedChannel = "email";
          }
        } else {
          console.log(res.data);
        }
      } catch (err) {
        console.log("Error", err);
      }
    },
    validateSMSCode() {
      this.didResendCode = false;
      this.returnmessageAr = [];
      this.hasErrors = [];

      const code = String(this.verificationCode || "").replace(/\D/g, "");
      if (code.length !== 6) {
        this.hasErrors.push("Enter all 6 digits of the verification code");
        this.returnmessageAr = this.hasErrors;
        this.formErrorsIsTrue = true;
        return;
      }

      this.verificationCode = code;
      this.formErrorsIsTrue = false;
      this.ConfirmSixDigitCode();
    },
    async ConfirmSixDigitCode() {
      //lets remove the resend confirmation if its on display
      this.didResendCode = false; 
      let content = {
        Sms: {
          API_Meth: "VerifyLoginCode",
          accountnumber: this.allData.patient.externId2,
          subaccountnumber: this.allData.patient.externId,
          verification_code: String(this.verificationCode || "").replace(/\D/g, ""),
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.status === "Code Matched") {
            this.codeState = "idle";
            // set 2FA verified and clear intended route
            store.commit('login/SET_2FA_VERIFIED', true);
            // GetSelfProfile is MFA-gated — load MySQL session self now.
            syncPrivilegesAfterSessionChange();
            const intended = store.state.login?.intendedRoute || null;
            store.commit('login/SET_INTENDED_ROUTE', null);
            document.getElementById('navigation-bar')?.style?.setProperty('display','block');
            Promise.resolve().then(() => {
              if (intended) router.push(intended).catch(()=>{});
              else router.push({ name: 'WelcomeNavigation' }).catch(()=>{});
            });
          } else {
            store.commit('login/SET_2FA_VERIFIED', false);
            // A locked-out user told "doesn't match" just guesses again.
            const fallback = this.codeRefusalFallback(res.data, "Verification code doesn't match. Try again or have a new code resent.");
            alert(refusalMessage(res.data) || fallback);
          }
        })
        .catch((err) => {
        console.error('VerifyLoginCode error:', err);
        const msg = err?.response?.data ? JSON.stringify(err.response.data) : (err.message || String(err));
        console.log('Error payload:', msg);
        // optional user feedback
         const fallback = this.codeRefusalFallback(err?.response?.data, 'Error verifying code. Please try again.');
         alert(refusalMessage(err?.response?.data) || fallback);
        return msg;
      });
    },
    // Records a locked or expired code (always, whether or not the server sent a
    // sentence) and returns the words to fall back on when it sent none.
    codeRefusalFallback(data, fallback) {
      const state = loginCodeRefusalState(data);
      if (state === "locked") {
        this.codeState = "locked";
        return "Too many incorrect codes. Please wait before trying again.";
      }
      if (state === "expired") {
        this.codeState = "expired";
        this.verificationCode = "";
        return "That code has expired. Send a new code.";
      }
      return fallback;
    },
    // Shared payload for first send and resend; includes selected channel.
    buildSendPayload() {
      return {
        Sms: {
          API_Meth: "Sms6DigitText",
          accountnumber: this.allData.patient.externId2,
          subaccountnumber: this.allData.patient.externId,
          // No smsPhone: the code goes to the number on file. This used to send
          // back the unmasked number the server had just handed over, which the
          // server then checked against its own copy - a guard that could only
          // ever agree with itself.
          channel: this.selectedChannel, // "sms" | "email" — drives GetSMSCode delivery path
        },
      };
    },
    // Shared success/error UI for SendSMSCode and ResendSendSMSCode.
    handleSendResponse(res, { isResend }) {
      if (this.isCodeSentResponse(res.data.message)) {
        // Remember which channel was used so copy shows the right masked contact.
        this.lastSentChannel = this.selectedChannel;
        this.showSMSSection = false;
        this.showSMSCodeSection = true;
        this.didResendCode = !!isResend;
        if (this.codeState === "expired") this.codeState = "idle";
        this.focusVerificationCode();
        return;
      }
      const refusal = refusalMessage(res.data);
      if (refusal) {
        alert(refusal);
        return;
      }
      if (res.data.error) {
        alert(res.data.message);
      } else if (res.data.message) {
        alert(res.data.message);
      } else if (res.data.error_code) {
        this.twilSMSError = true;
        alert(res.data.message);
      } else {
        console.log(res.data);
        alert("Code Not Sent Successfully");
      }
    },
    // First send (step 1). Name is historical — also sends via email when channel is email.
    async SendSMSCode() {
      this.didResendCode = false;
      this.twilSMSError = false;
      try {
        const res = await axios.post(
          CURR_API + "/tswebhook.php",
          this.buildSendPayload(),
          { headers: { "Content-Type": "application/json;" } }
        );
        this.handleSendResponse(res, { isResend: false });
      } catch (err) {
        console.log("Error", err);
        const refusal = refusalMessage(err?.response?.data);
        if (refusal) alert(refusal);
      }
    },
    // Resend from step 2; uses current selectedChannel so user can switch SMS <-> email.
    async ResendSendSMSCode() {
      this.twilSMSError = false;
      try {
        const res = await axios.post(
          CURR_API + "/tswebhook.php",
          this.buildSendPayload(),
          { headers: { "Content-Type": "application/json;" } }
        );
        this.handleSendResponse(res, { isResend: true });
      } catch (err) {
        console.log("Error", err);
        const refusal = refusalMessage(err?.response?.data);
        if (refusal) alert(refusal);
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "../../stylesheets/mixins/alignment";
/* Colors/fonts live in the stylebook (.eh-ds in brand-ds.scss). Layout stays here. */

.content {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  position: relative;
  background: none;
}

.content::before {
  content: "";
  position: fixed;
  inset: 0;
  z-index: 0;
  background: url("../../assets/images/bg.jpg") no-repeat center center;
  background-size: cover;
}

.auth-wrapper {
  min-height: 100vh;
  min-height: 100dvh;
  width: 100%;
  position: relative;
  z-index: 1;
  padding: 1.5rem;
  box-sizing: border-box;
}

.auth-card {
  padding: 2rem;
  @include absoluteCenter(420px);
}

.auth-form {
  width: 100%;
}

.auth-section {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  text-align: center;
}

.auth-title {
  font-size: 1.5rem;
  margin: 0 0 0.75rem;
}

.auth-text {
  font-size: 0.95rem;
  line-height: 1.5;
  margin: 0 0 1rem;
}

.auth-error {
  font-size: 0.9rem;
  margin: 0 0 1rem;
}

.channel-options {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin: 0 0 1.25rem;
  text-align: left;
}

.channel-options--compact {
  margin-bottom: 1rem;
}

.channel-options__hint {
  margin: 0;
  font-size: 0.85rem;
}

.channel-option {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  border-radius: 6px;
  padding: 0.75rem 1rem;
  cursor: pointer;

  input {
    margin-top: 0.2rem;
  }
}

.channel-option__body {
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
}

.channel-option__label {
  font-size: 0.95rem;
}

.channel-option__value {
  font-size: 0.9rem;
  letter-spacing: 0.04em;
  word-break: break-all;
}

.auth-alert {
  border-radius: 6px;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  text-align: left;
  font-size: 0.9rem;
}

.auth-alert--success {
  text-align: center;
}

.auth-alert__title {
  margin: 0 0 0.5rem;
  text-align: center;
}

.auth-alert__list {
  margin: 0;
  padding-left: 1.25rem;
}

.codebox {
  display: flex;
  justify-content: center;
  margin: 0 auto 1.5rem;
  max-width: 100%;
}

.code-input {
  width: 100%;
  max-width: 240px;
  height: 56px;
  font-size: 1.75rem;
  letter-spacing: 0.35em;
  text-align: center;
  border-radius: 6px;
  padding: 0 0.75rem;
  box-sizing: border-box;
}

.auth-actions {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.auth-btn {
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border-radius: 4px;
  cursor: pointer;
}

@media only screen and (max-width: 468px) {
  .auth-wrapper {
    padding: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .auth-card {
    position: static;
    transform: none;
    left: auto;
    top: auto;
    width: 100%;
    max-width: 100%;
    padding: 1.5rem 1.25rem;
    margin: 0;
  }

  .auth-title {
    font-size: 1.25rem;
  }

  .auth-text {
    font-size: 0.9rem;
  }

  .code-input {
    max-width: 100%;
    height: 48px;
    font-size: 1.35rem;
    letter-spacing: 0.28em;
    border-radius: 4px;
  }
}

@media only screen and (max-width: 360px) {
  .code-input {
    height: 44px;
    font-size: 1.2rem;
    letter-spacing: 0.22em;
  }
}
</style>
